import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import Header from "../../components/Header";
import DebatesAdmin from "./DebatesAdmin";
import ListTypesAdmin from "./ListTypesAdmin";
import MetadataAdmin from "./MetadataAdmin";
import CacheAdmin from "./CacheAdmin";
import DashboardAdmin from "./DashboardAdmin";

const Admin = () => {
  const [activeTab, setActiveTab] = useState("dashboard");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const tab = urlParams.get("tab");
    if (tab) {
      setActiveTab(tab);
    }
  }, [location]);

  const changeTab = (tab: string) => {
    setActiveTab(tab);
    navigate(`?tab=${tab}`);
  };

  return (
    <>
      <Header />
      <div className="min-h-screen bg-gray-900 text-white">
        {/* Admin Navigation */}
        <div className="bg-gray-800 border-b border-gray-700">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <nav className="flex space-x-8">
              <button
                onClick={() => changeTab("dashboard")}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  activeTab === "dashboard"
                    ? "border-blue-500 text-blue-400"
                    : "border-transparent text-gray-300 hover:text-white hover:border-gray-300"
                }`}
              >
                Dashboard
              </button>
              <button
                onClick={() => changeTab("debates")}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  activeTab === "debates"
                    ? "border-blue-500 text-blue-400"
                    : "border-transparent text-gray-300 hover:text-white hover:border-gray-300"
                }`}
              >
                Debates
              </button>
              <button
                onClick={() => changeTab("listtypes")}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  activeTab === "listtypes"
                    ? "border-blue-500 text-blue-400"
                    : "border-transparent text-gray-300 hover:text-white hover:border-gray-300"
                }`}
              >
                List Types
              </button>
              <button
                onClick={() => changeTab("metadata")}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  activeTab === "metadata"
                    ? "border-blue-500 text-blue-400"
                    : "border-transparent text-gray-300 hover:text-white hover:border-gray-300"
                }`}
              >
                Metadata
              </button>
              <button
                onClick={() => changeTab("cache")}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  activeTab === "cache"
                    ? "border-blue-500 text-blue-400"
                    : "border-transparent text-gray-300 hover:text-white hover:border-gray-300"
                }`}
              >
                Cache &amp; Ranks
              </button>
            </nav>
          </div>
        </div>

        {/* Content Area */}
        {activeTab === "debates" ? (
          <DebatesAdmin />
        ) : activeTab === "listtypes" ? (
          <ListTypesAdmin />
        ) : activeTab === "metadata" ? (
          <MetadataAdmin />
        ) : activeTab === "cache" ? (
          <CacheAdmin />
        ) : (
          <DashboardAdmin />
        )}
      </div>
    </>
  );
};

export default Admin;
